if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      try {
        const bundleSelector = this.closest('.product__info-wrapper')?.querySelector('dyefor-party-bundle');
        const useAtomicBundleRequest = bundleSelector?.addSelectedItems
          && bundleSelector.selectedMode !== 'single';
        let responseData;

        if (useAtomicBundleRequest) {
          const sections = this.cart
            ? this.cart.getSectionsToRender().map((section) => section.id)
            : [];
          if (this.cart) this.cart.setActiveElement(document.activeElement);

          responseData = await bundleSelector.addSelectedItems(this.form, {
            sections,
            sectionsUrl: window.location.pathname
          });
        } else {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          for (const name of Array.from(formData.keys())) {
            const match = name.match(/^properties\[(.+)\]$/);
            if (match && /^_Dyefor\b|^_Matches design$/i.test(match[1])) formData.delete(name);
          }
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          const response = await fetch(`${routes.cart_add_url}`, config);
          responseData = await response.json();
        }

        if (responseData.status) {
          this.handleErrorMessage(responseData.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
          }
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(responseData) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(responseData);
        }
      } catch (error) {
        console.error(error);
        this.error = true;
        this.handleErrorMessage(error.message || 'This set could not be added. Please try again.');
      } finally {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
